<template>
  <div class="navigation-menu" v-if="user && route != 'login'">
    <div class="navigation-container">
      <div
        v-if="user != null"
        class="navigation-block"
        :class="{ 'tab-open': selection.user }"
        @auxclick="newWindow(getRoute('edit-account'))"
        @click="selectUser"
      >
        {{ user.company.code }}
        <span class="user-info">{{ user.name }} ({{ userType }})</span>
      </div>
      <div
        class="navigation-block"
        :class="{ 'tab-open': selection.orders }"
        @auxclick="newWindow(getRoute('orders'))"
        @click="selectOrders"
      >
        {{ $t("navigation_menu.orders") }}
      </div>
      <div
        v-if="user.type != 6"
        class="navigation-block"
        :class="{ 'tab-open': selection.planning }"
        @auxclick="newWindow(getRoute('preperation'))"
        @click="selectPlanning"
      >
        {{ $t("navigation_menu.production_planning") }}
      </div>
      <div
        v-if="user.type != 6"
        class="navigation-block"
        :class="{ 'tab-open': selection.production }"
        @auxclick="newWindow(getRoute('production'))"
        @click="selectProduction"
      >
        {{ $t("navigation_menu.production") }}
      </div>
      <div
        class="navigation-block"
        :class="{ 'tab-open': selection.packing }"
        @auxclick="newWindow(getRoute('pallet-planning'))"
        @click="selectPacking"
      >
        {{ $t("navigation_menu.packing") }}
      </div>
      <div
        v-if="user.type != 6"
        class="navigation-block"
        :class="{ 'tab-open': selection.warehouse }"
        @click="selectWarehouse"
      >
        {{ $t("navigation_menu.warehouse") }}
      </div>
      <div
        v-if="user.type != 6"
        class="navigation-block"
        :class="{ 'tab-open': selection.company }"
        @auxclick="newWindow(getRoute('company'))"
        @click="selectCompany"
      >
        {{ $t("navigation_menu.company") }}
      </div>
      <div class="navigation-block" @click="logout">
        {{ $t("navigation_menu.logout") }}
      </div>
    </div>
    <div class="navigation-selection">
      <div v-if="selection.user" class="navigation-selection-list">
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('edit-account') }"
          @auxclick="newWindow(getRoute('edit-account'))"
          @click="navigate(getRoute('edit-account'))"
          v-if="user.type <= 3"
        >
          {{ $t("navigation_menu.account") }}
        </div>
      </div>
      <div class="navigation-selection-list" v-if="selection.orders">
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen(['orders', 'products'], 100) }"
          @auxclick="newWindow(getRoute('orders'))"
          @click="navigate(getRoute('orders'))"
        >
          {{ $t("navigation_menu.orders") }}
        </div>
      </div>
      <div v-if="selection.planning" class="navigation-selection-list">
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('preperation') }"
          @auxclick="newWindow(getRoute('preperation'))"
          @click="navigate(getRoute('preperation'))"
        >
          {{ $t("navigation_menu.preperation") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('suppliers') }"
          @auxclick="newWindow(getRoute('suppliers'))"
          @click="navigate(getRoute('suppliers'))"
          v-if="user.type <= 1"
        >
          {{ $t("navigation_menu.suppliers") }}
        </div>
      </div>
      <div v-if="selection.production" class="navigation-selection-list">
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('production') }"
          @auxclick="newWindow(getRoute('production'))"
          @click="navigate(getRoute('production'))"
        >
          {{ $t("navigation_menu.monitoring") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('work-center') }"
          @click="workCenter"
        >
          {{ $t("navigation_menu.work_centers") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('status-change') }"
          @auxclick="newWindow(getRoute('status-change'))"
          @click="navigate(getRoute('status-change'))"
          v-if="user.type <= 3"
        >
          {{ $t("navigation_menu.change_product_statuses") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('work-centers-management') }"
          @auxclick="newWindow(getRoute('work-centers-management'))"
          @click="navigate(getRoute('work-centers-management'))"
          v-if="user.type <= 1"
        >
          {{ $t("navigation_menu.manage_work_centers") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('product-set') }"
          @auxclick="newWindow(getRoute('product-set'))"
          @click="navigate(getRoute('product-set'))"
          v-if="user.type <= 1"
        >
          {{ $t("navigation_menu.product_set") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('tools') }"
          @auxclick="newWindow(getRoute('tools'))"
          @click="navigate(getRoute('tools'))"
          v-if="user.type <= 1"
        >
          {{ $t("navigation_menu.tools") }}
        </div>
      </div>
      <div v-if="selection.packing" class="navigation-selection-list">
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('pallet-planning') }"
          @click="packPallets"
        >
          {{ $t("navigation_menu.packing_page") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('pallets') }"
          @auxclick="newWindow(getRoute('pallets'))"
          @click="navigate(getRoute('pallets'))"
        >
          {{ $t("navigation_menu.pallets") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('trucks-list') }"
          @auxclick="newWindow(getRoute('trucks'))"
          @click="navigate(getRoute('trucks'))"
        >
          {{ $t("navigation_menu.dispatches") }}
        </div>
        <div
          v-if="user.type != 6"
          class="selection-item"
          :class="{ 'page-open': checkOpen('scanner') }"
          @auxclick="newWindow(getRoute('scanner'))"
          @click="navigate(getRoute('scanner'))"
        >
          {{ $t("navigation_menu.scan") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('packing-types') }"
          @auxclick="newWindow(getRoute('packing-types'))"
          @click="navigate(getRoute('packing-types'))"
          v-if="canManagePackingTypes"
        >
          {{ $t("navigation_menu.packing_types") }}
        </div>
      </div>
      <div v-if="selection.warehouse" class="navigation-selection-list"></div>
      <div
        v-if="selection.company && isAdmin"
        class="navigation-selection-list"
      >
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('company') }"
          @auxclick="newWindow(getRoute('company'))"
          @click="navigate(getRoute('company'))"
          v-if="isAdmin"
        >
          {{ $t("navigation_menu.company") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('user') }"
          @auxclick="newWindow(getRoute('user'))"
          @click="navigate(getRoute('user'))"
          v-if="isAdmin"
        >
          {{ $t("navigation_menu.users") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('customers') }"
          @auxclick="newWindow(getRoute('customers'))"
          @click="navigate(getRoute('customers'))"
          v-if="hasRights('CA_NEW')"
        >
          {{ $t("navigation_menu.customers") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('problems') }"
          @auxclick="newWindow(getRoute('problems'))"
          @click="navigate(getRoute('problems'))"
        >
          {{ $t("navigation_menu.changes_register") }}
        </div>
        <div
          class="selection-item"
          :class="{ 'page-open': checkOpen('pdf-templates') }"
          @auxclick="newWindow(getRoute('pdf-templates'))"
          @click="navigate(getRoute('pdf-templates'))"
        >
          {{ $t("navigation_menu.pdf_templates") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "@/models/User.js";
import WorkCenter from "@/models/WorkCenter.js";
export default {
  props: ["isAdmin", "isUserSet"],
  data() {
    return {
      user:
        this.$session.get("user") != null
          ? new User(this.$session.get("user"))
          : null,
      open: false,
      selection: {
        user: false,
        planning: false,
        production: false,
        packing: false,
        warehouse: false,
        company: false,
      },
      defaultSelection: {
        user: false,
        planning: false,
        production: false,
        packing: false,
        warehouse: false,
        company: false,
      },
      route: this.$route.name,
    };
  },
  created() {
    this.getTab();
  },
  computed: {
    canManagePackingTypes() {
      return this.user.hasRights("PT_EDIT");
    },
    userType() {
      if (this.user == null) {
        return false;
      }
      switch (this.user["type"]) {
        case 0:
          return this.$t("header.super");
        case 1:
          return this.$t("header.admin");
        case 2:
          return this.$t("header.planner");
        case 3:
          return this.$t("header.manager");
        case 4:
          return this.$t("header.packer");
        default:
          return this.$t("header.simple_user");
      }
    },
  },
  methods: {
    selectUser() {
      this.openUser();
      this.navigate(this.getRoute("edit-account"));
    },

    selectOrders() {
      this.openOrders();
      this.navigate(this.getRoute("orders"));
    },

    selectPlanning() {
      this.openPlanning();
      this.navigate(this.getRoute("preperation"));
    },

    selectProduction() {
      this.openProduction();
      this.navigate(this.getRoute("production"));
    },

    selectPacking() {
      this.openPacking();
      this.navigate(this.getRoute("pallet-planning"));
    },

    selectWarehouse() {
      this.openWarehouse();
    },

    selectCompany() {
      this.openCompany();
      this.navigate(this.getRoute("company"));
    },

    openOrders() {
      const newSelection = { ...this.defaultSelection };
      newSelection.orders = true;
      this.selection = newSelection;
      this.open = true;
    },

    openUser() {
      const newSelection = { ...this.defaultSelection };
      newSelection.user = true;
      this.selection = newSelection;
      this.open = true;
    },

    openPlanning() {
      const newSelection = { ...this.defaultSelection };
      newSelection.planning = true;
      this.selection = newSelection;
      this.open = true;
    },

    openProduction() {
      const newSelection = { ...this.defaultSelection };
      newSelection.production = true;
      this.selection = newSelection;
      this.open = true;
    },
    openPacking() {
      const newSelection = { ...this.defaultSelection };
      newSelection.packing = true;
      this.selection = newSelection;
      this.open = true;
    },
    openWarehouse() {
      const newSelection = { ...this.defaultSelection };
      newSelection.warehouse = true;
      this.selection = newSelection;
      this.open = true;
    },
    openCompany() {
      const newSelection = { ...this.defaultSelection };
      newSelection.company = true;
      this.selection = newSelection;
      this.open = true;
    },

    logout() {
      this.$session.destroy();
      this.$router.push({ name: "login" }).catch(() => {});
      this.$router.go();
    },

    navigate(route) {
      this.$router.push(route);
      if (route.name === "work-centers-management") {
        this.$router.go();
      }
    },

    newWindow(route) {
      let routeData = this.$router.resolve(route);
      window.open(routeData.href, "_blank");
    },

    getRoute(name) {
      const perPage =
        localStorage.getItem("orders-per-page") != null
          ? parseInt(localStorage.getItem("orders-per-page"))
          : 50;
      switch (name) {
        case "orders":
          return {
            path: `/${this.$router.currentRoute.params.lang}/orders/null/null/null/0/100/${perPage}/1/null/false`,
          };
        case "planning-orders":
          return {
            path: `/${this.$router.currentRoute.params.lang}/orders/null/null/null/4/7/${perPage}/1/null/false`,
          };
        case "user":
          return { name: "user" };
        case "status-change":
          return { name: "status-change" };
        case "company":
          return { name: "company" };
        case "packing-types":
          return { name: "packing-types" };
        case "customers":
          return "customers";
        case "trucks":
          return {
            path: `/${this.$router.currentRoute.params.lang}/trucks-list/null/null/null/1/100/1/null/true`,
          };
        case "scanner":
          return { name: "scanner" };
        case "pallets":
          return {
            path: `/${this.$router.currentRoute.params.lang}/pallets/null/0/100/1/number/true`,
          };
        case "vehicles":
          return { name: "vehicles" };
        case "edit-account":
          return { name: "edit-account" };
        case "production":
          return { name: "production" };
        case "work-centers-management":
          return { name: "work-centers-management" };
        case "problems":
          return { name: "problems" };
        case "product-set":
          return { name: "product-set" };
        case "tools":
          return { name: "tools" };
        case "preperation":
          return { name: "preperation" };
        case "suppliers":
          return { name: "suppliers" };
        case "pdf-templates":
          return { name: "pdf-templates" };
        case "pallet-planning":
          return {
            path: `/${this.$router.currentRoute.params.lang}/pallet-planning`,
          };
      }
    },

    hasRights(right) {
      return this.user.hasRights(right);
    },

    packPallets() {
      this.$router.push({
        path: `/${this.$router.currentRoute.params.lang}/pallet-planning`,
      });
    },

    async workCenter() {
      const workCenters = await WorkCenter.loadCenters();
      if (workCenters.length == 0) return;
      const sorted = workCenters.sort((a, b) => {
        if (a.code < b.code) {
          return -1;
        }
        if (a.code > b.code) {
          return 1;
        }
        return 0;
      });
      this.$router
        .push({ name: "work-center", params: { id: sorted[0].id } })
        .catch(() => {});
    },

    getTab() {
      const routeName = this.$route.name;
      const ordersRoutes = ["orders"];
      const userRoutes = ["edit-accounts"];
      const productionPlanningRoutes = ["preperation", "suppliers"]; // statuses 4 - 7
      const productionRoutes = [
        "production",
        "work-center",
        "status-change",
        "work-centers-management",
        "product-set",
        "tools",
      ];
      const packingRoutes = [
        "products",
        "pallets",
        "trucks-list",
        "pallet-planning",
        "scanner",
        "packing-types",
      ];
      const wareHouseRoutes = [];
      const companyRoutes = [
        "company",
        "user",
        "customers",
        "problems",
        "pdf-templates",
      ];
      if (
        ordersRoutes.includes(routeName) &&
        this.$route.params.status_from != 4
      ) {
        this.openOrders();
      }
      if (userRoutes.includes(routeName)) {
        this.openUser();
      }
      if (productionPlanningRoutes.includes(routeName)) {
        this.openPlanning();
      }
      if (productionRoutes.includes(routeName)) {
        this.openProduction();
      }
      if (packingRoutes.includes(routeName)) {
        this.openPacking();
      }
      if (wareHouseRoutes.includes(routeName)) {
        this.openWarehouse();
      }
      if (companyRoutes.includes(routeName)) {
        this.openCompany();
      }
    },

    checkOpen(routeName, additionalCheck) {
      const openName = this.$route.name;
      if (additionalCheck) {
        if (this.$route.params.status_to != additionalCheck) return false;
      }
      if (Array.isArray(routeName)) {
        if (routeName.includes(openName)) {
          return true;
        }
      }
      return routeName == openName;
    },
  },
};
</script>

<style scoped>
.navigation-container {
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 5px 5px;
}
.tab-open {
  background: rgb(21, 194, 224);
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.page-open {
  color: black !important;
  background: white;
}
.navigation-block {
  cursor: pointer;
  color: white;
  padding: 5px;
  height: 40px;
}
.navigation-selection {
  position: absolute;
  z-index: 100;
  background: rgb(21, 194, 224);
  top: 40px;
  left: 0px;
  width: 100%;
  height: 30px;
}
.navigation-selection-list {
  margin-top: 5px;
}
.selection-item {
  display: inline;
  padding-top: 2px;
  padding-left: 7px;
  padding-right: 7px;
  padding-bottom: 7px;
  color: white;
  font-weight: 400;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
}
.user-info {
  font-size: 12px;
  color: white;
}
.link {
  text-decoration: none;
  color: white;
}
.selected-link {
  color: black;
}
</style>
